<template>
  <v-flex
    column
    role="region"
    aria-label="Guides content"
  >
    <v-parallax
      src="https://gm.goz.fun/wp-content/uploads/2023/03/guide-cover.png"
      height="350"
      role="img"
      aria-label="Guides section banner"
    />
    <v-card flat>
      <v-layout
        column
        pb-2
        role="region"
        aria-label="Guides layout"
      >
        <v-flex
          xs12
          sm12
          md12
          lg8
          justify-center
        >
          <search
            subject="guides"
            :limit="limit"
            aria-label="Search guides"
            @onChangedText="onSearchChange"
          />

          <v-layout
            column
            pb-2
          >
            <v-flex
              xs12
              sm12
              md12
              lg8
              justify-center
              text-center
            >
              <v-btn
                class="guides-buttons-disenchantment"
                color="accent"
                type="button"
                aria-label="Disenchantment button"
                @click="goToDisenchantmentCollection"
              >
                {{ $t('components.guides.buttons.disenchantment') }}
              </v-btn>
            </v-flex>
          </v-layout>

          <posts
            :posts="posts"
            :title="$t('components.guides.title')"
            :is-loading="isLoading"
            role="region"
            aria-label="Guides posts section"
          />
        </v-flex>
      </v-layout>
    </v-card>
  </v-flex>
</template>


<script>
import { toPaginatedPosts, searchPost } from "@/utils/post.utils";

export default {
  name: "GuidesLayout",
  components: {
    Posts: () => import("@/components/Views/Posts.vue"),
    Search: () => import("@/components/Views/Search.vue"),
  },
  data() {
    return {
        apiGuides: [],
        searchText: "",
        limit: 100,
        isLoading: true,
    }
  },
  computed: {
      posts() {
          return this.searchText
            ? toPaginatedPosts(searchPost(this.apiGuides, this.searchText), "")
            : toPaginatedPosts(this.apiGuides, this.$route.query.slug);
      }
  },
  watch: {
      posts() {
        this.isLoading = false;
      }
  },
  async mounted() {
    this.apiGuides = await this.$api.getGuides(this.limit);
  },
  methods: {
    async onSearchChange(searchText) {
        this.isLoading = true;
        this.searchText = searchText;
    },
    goToDisenchantmentCollection() {
        this.$router.push({
            name: "client.guides.disenchantment.collection"
        });
    }
  }
};
</script>
